import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = localStorage.getItem('lang') || 'pt';

    const languageMap: { [key: string]: string } = {
      'pt': 'pt-BR',
      'en': 'en-US',
      'es': 'es-ES'
    };

    const acceptLanguage = languageMap[lang] || 'pt-BR';

    // Não definir Content-Type para FormData (uploads de arquivo)
    // O Angular automaticamente define multipart/form-data com boundary correto
    const headers: { [key: string]: string } = {
      'Accept-Language': acceptLanguage
    };

    // Só adicionar Content-Type: application/json se não for FormData
    if (!(request.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    const modifiedRequest = request.clone({
      setHeaders: headers
    });

    return next.handle(modifiedRequest);
  }
}
